var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"main-container",attrs:{"id":"bid-equipment","fluid":"","tag":"section"}},[_c('idc-component-bid-equipments',{attrs:{"can-read":_vm.canRead,"can-edit":false,"can-delete":false,"url-specification":_vm.urlSpecification,"bid-number":_vm.bidNumber,"settings":_vm.settings}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }